import { Backdrop, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

const useStylesLoading = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    position: 'absolute',
    background: 'none',
  },

}));

export const LoadingElement = () => {
  const classes = useStylesLoading();
  return (
    <Backdrop className={classes.backdrop} open>
      <CircularProgress color='inherit' size='1.5rem' />
    </Backdrop>
  );
};
